export function persianDate(monthType = "numeric") {
  const formatter = new Intl.DateTimeFormat("fa-IR", {
    weekday: "long",
    year: "numeric",
    month: monthType,
    day: "numeric",
  });
  const parts = formatter.formatToParts(new Date());
  const get = (type) => parts.find(p => p.type === type)?.value || "";
  const dateText = monthType === "numeric" ? `${get("weekday")} ${get("day")} / ${get("month")} / ${get("year")}` : `${get("weekday")}, ${get("day")} ${get("month")} ${get("year")}`;
  const date = `${get("day")} / ${get("month")} / ${get("year")}`;
  return {dateText, date};
}
